import FrontendLogger, {Severity} from "~/services/FrontendLoggerService/FrontendLogger"

let logger: FrontendLogger | undefined
export const useFrontendLogger = () => {
  if (!logger) {
    logger = new FrontendLogger()
    const config = useRuntimeConfig()
    if (config.public.sentry?.logLevel && Object.values(Severity).includes(config.public.sentry?.logLevel as Severity)) {
      logger?.setLevel(config.public.sentry?.logLevel as Severity)
    }
  }
  return logger
}